import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { withModalActions } from 'core/hocs';
import { RESPONSE_STATUSES } from 'core/constants';
import { FormattedTag } from 'core/components';
import { removeWhitespace } from 'core/helpers';
import { ModalWindow } from 'components/modal-window/modal-window';
import { IconAlert } from 'components/icons/icon-alert/icon-alert';
import colors from 'src/customizations/js/color-variables';
import { MODAL_IDS } from 'src/constants';

import './bonus-redeem-warning-modal.scss';

const getTranslationKey = ({ responseStatus, bonusPlanName }) => {
  const prefix = 'promo.bonuses.bonus-redeem-warning.modal.';
  let suffix = '';

  if (responseStatus === RESPONSE_STATUSES.SUCCESS) {
    suffix = removeWhitespace(bonusPlanName);
  }

  if (responseStatus === RESPONSE_STATUSES.TAG_EXCLUDED) {
    suffix = 'tag-excluded';
  }

  if (responseStatus === RESPONSE_STATUSES.NOT_FOUND) {
    suffix = 'not-found';
  }

  return {
    title: `${prefix}title.${suffix}`,
    desc: `${prefix}desc.${suffix}`,
  };
};

export class BonusRedeemWarningModalUI extends Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    currentModal: PropTypes.shape({
      id: PropTypes.string,
      data: PropTypes.any,
    }).isRequired,
  };

  closeModal = () => {
    const { closeModal } = this.props;
    closeModal(MODAL_IDS.BONUS_REDEEM_WARNING);
  }

  render() {
    const { currentModal } = this.props;

    const bonusCode = currentModal?.data?.bonusCode ?? '';
    const responseStatus = currentModal?.data?.responseStatus ?? '';
    const bonusPlanName = currentModal?.data?.bonusPlanName ?? '';

    return (
      <ModalWindow
        id={MODAL_IDS.BONUS_REDEEM_WARNING}
        coreProps={{ id: MODAL_IDS.BONUS_REDEEM_WARNING }}
        closeButtonClassName="invisible"
        isCentered
        fade
      >
        <div className="d-flex flex-column justify-content-between align-items-center bonus-redeem-warning-modal">
          <IconAlert className="icon-alert" outlined color={colors.primary} />
          <FormattedTag
            id={getTranslationKey({ responseStatus, bonusPlanName }).title}
            values={{
              bonusCode,
            }}
            className="h2 text-center my-2_5"
          />
          <FormattedTag
            id={getTranslationKey({ responseStatus, bonusPlanName }).desc}
            className="text-gray-20 text-center"
          />
          <FormattedTag
            tag={Button}
            color="primary"
            className="px-7_25 mt-2_5 mb-7 w-100"
            id="got-it"
            onClick={this.closeModal}
          />
        </div>
      </ModalWindow>
    );
  }
}

export const BonusRedeemWarningModal = withModalActions(BonusRedeemWarningModalUI);
